import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import jobActions from '../../../actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import Api from '../../../../../../helpers/api';
import { keyByProperty } from '../../../../../../helpers/core';
import { t } from '../../../../../../i18n';

const api = new Api('shifts');

function* loadFormData(shiftToEdit) {
  try {
    const result = yield call(sendRequest, api.loadFormData, {}, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result;

      yield put(actions.loadFormDataSuccess({ data, shiftToEdit }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* updateShift({ payload }) {
  try {
    const { editForm, id, jobId, cb, pages } = payload;

    const propsArray = Object.values(editForm);
    const shift = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(sendRequest, api.updateItem, { data: { shift }, id }, notifications.REQUEST_ERROR);

    if (result) {
      if (result.data) {
        yield put(actions.saveSuccess());

        if (jobId) {
          yield put(jobActions.loadData({ id: jobId, pages }));
        }
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.updated_successfully', { item: t('dash.jobs.bookings.shift_title') }),
          }),
        );

        if (cb) {
          cb();
        }
      } else {
        yield put(
          actions.saveError({
            data: result,
          }),
        );
      }
    } else if (jobId) {
      yield put(jobActions.loadData({ id: jobId, pages }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.SAVE, updateShift), takeEvery(actions.LOAD, loadFormData)]);
}
